<template>
  <div
    class="input-field"
    :class="{ 'error': validationErrors?.length }"
  >
    <label v-if="label">
      {{ label }}
    </label>

    <div class="flex">
      <input
        v-model="model"
        :required="required"
        maxlength="255"
        :type="showPassword ? 'password' : 'text'"
      >

      <span
        class="relative bg-white"
        :title="showPassword ? 'Show' : 'Hide'"
        @click="showPassword = !showPassword"
      >
        <span
          v-show="!showPassword"
          class="absolute right-0 flex items-center border border-gray-300 rounded-l-none rounded-md px-2 h-full hover:cursor-pointer hover:bg-gray-100"
        >
          <i

            class="fas fa-eye-slash fa-fw text-app-gray-primary"
          />
        </span>

        <span
          v-show="showPassword"
          class="absolute right-0 flex items-center border border-gray-300 rounded-l-none rounded-md px-2 h-full hover:cursor-pointer hover:bg-gray-100"
        >
          <i
            class="fas fa-eye fa-fw text-app-gray-primary"
          />
        </span>
      </span>
    </div>

    <span
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation-error-message fs-9 block"
    >
      {{ error }}
    </span>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const model = defineModel({ type: String, default: '' });

const showPassword = ref(true);

defineProps({
  validationErrors: {
    type: Array,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: null,
  },
});
</script>
